export default "__VITE_ASSET__CwgcL0I1__"